import { ButtonBase } from '@mui/material'
import type { CSSProperties, FC } from 'react'
import type { GenerationModel } from 'src/services/apollo/generated/graphql'
import { GenerationModelMarkType } from 'src/services/apollo/generated/graphql'
import { executeMarkGenerationModel } from 'src/services/apollo/generation-model'
import { cx } from 'src/utils/cx'
import { formatNum } from 'src/utils/formatNum'
import { track } from 'src/utils/tracker'
import BaseLikeButton from '../LikeButton/BaseLikeButton'
import { LikeHeart } from '../LikeButton/LikeHeart'

const ModelLikeButton: FC<{
  modelId: string
  model?: GenerationModel
  initialValue?: boolean
  initialCount?: number
  countStyle?: CSSProperties
  countClassName?: string
  numOnTop?: boolean
  hideValueOnZero?: boolean
  scene?: string
}> = ({
  modelId,
  model,
  initialValue = model?.liked ?? false,
  initialCount = model?.likedCount ?? 0,
  countStyle,
  countClassName,
  numOnTop,
  hideValueOnZero,
  scene = 'market',
}) => {
  if (!modelId) return null
  return (
    <BaseLikeButton
      id={modelId}
      initialCount={initialCount}
      initialValue={initialValue}
      onBtnClick={target => {
        if (target) {
          track('like_click', {
            scene,
            type: model?.type,
          })
        }
      }}
      handler={async (id, target) => {
        await executeMarkGenerationModel({
          modelId: id,
          type: GenerationModelMarkType.Like,
          target,
        })
      }}
      render={({ value, count, onClick }) => {
        const button = (
          <ButtonBase
            component="div"
            role="button"
            className="cursor-pointer outline transition -m-2 p-2 rounded-md"
            onClick={onClick}
          >
            <div
              className={cx('flex gap-1 items-center', {
                'flex-col-reverse': numOnTop,
              })}
            >
              <LikeHeart liked={value} className="size-5" />
              {hideValueOnZero && !count ? null : (
                <span
                  className={cx(countClassName, 'text-sm tabular-nums')}
                  style={{
                    ...countStyle,
                  }}
                >
                  {formatNum(count || 0)}
                </span>
              )}
            </div>
          </ButtonBase>
        )
        return button
      }}
    />
  )
}

export default ModelLikeButton
